import React from "react";
import "./styled.css";

export default function Podium(props) {
  const { ranking, clasdPodium, order, imgPodium, podiumTextColor = 'white' } = props;

  return (
    <>
      <div className="div-singlePodio">
        <img src={imgPodium} className="img-topPodium" />

        <a className="title-podio" style={{ color: podiumTextColor }}>{ranking && ranking.name}</a>
        <div className={`podio ${clasdPodium}`}>
          <a style={{ color: podiumTextColor }}>{order}</a>
          <a style={{ color: podiumTextColor }}>{ranking && `${ranking.totalPoints} Pontos`}</a>
        </div>
      </div>
    </>
  );
}
